import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "vab-app-main"
};
import { useRoutesStore } from '@/store/modules/routes';
import { handleActivePath } from '@/utils/routes';

import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import { watch } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const routesStore = useRoutesStore();
    const {
      tab,
      activeMenu
    } = storeToRefs(routesStore);
    watch(route, () => {
      if (tab.value.data !== route.matched[0].name) tab.value.data = route.matched[0].name;
      activeMenu.value.data = handleActivePath(route);
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_vab_router_view = _resolveComponent("vab-router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("section", null, [_createVNode(_component_vab_router_view)])]);
    };
  }
});